import { Component, ElementRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Api } from 'src/app/services/api';
import { Globals } from 'src/app/services/globals';
import { IPoster } from '../../../../../../../common/common-interfaces/poster';

@Component({
    selector: 'posters',
    templateUrl: './posters.component.html',
    styleUrls: ['./posters.component.scss'],
    standalone: false
})
export class PostersComponent {
  posters: IPoster[] = [];
  searchText: string = '';
  searchShopStatus: string = 'ALL';

  constructor(private api: Api, private router: Router, private route: ActivatedRoute, public globals: Globals) {

  }

  async ngOnInit() {
    this.posters = await this.api.store().get<any>(`/posters/latest`);

  }

  async search() {

    this.posters = await this.api.store().get<any>(`/posters/search?q=${this.searchText}&shopStatus=${this.searchShopStatus}`);
  }


  async newPoster(){
    let poster = await this.api.store().post<any>(`/posters/new`, {});
    this.router.navigate([this.globals.panelUrl(`/posters/${poster._id}`)]);
  }


}


